import {
  ChevronDownSquare,
  SearchIcon,
  Play,
  Send,
  WrenchIcon,
  Badge,
  PlugIcon,
  MailIcon,
  Loader,
  Download,
  // CircleDashed,
  RotateCcw,
  ListPlus,
  SlidersHorizontal,
  Cog,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectLabel,
} from "@components/ui/select";

import { Button } from "@components/ui/button";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import React from "react";
import {
  addAnomalyToEmailList,
  getActionDropdown,
  // getAnomalyAutomationStatus,
} from "@services/api/amlAnomalyDetection";
import { EventProp } from "@components/common/CommonTypes";
import { toast } from "@components/ui/use-toast";
import IncidentOverview from "@components/common/IncidentOverview";
import AnomalyFixedDialog from "./AnomalyFixedDialog";
import PcapDownloadDialog from "./PcapDownloadDialog";
import TrustedListDialog from "./TrustedListDialog";
import PluginActionDialog from "./PluginActionDialog";
import { getShadow360URL } from "@utils/utils";
import TcpResetDialog from "./TcpResetDialog";
import AddToDataList from "./AddToDataList";
import AnomalyTuningModal from "./AnomalyTuningDialog";
// import AutomationStatus from "./AutomationStatus";
// import { AMLDropdownProps } from "@components/common/CommonTypes";

interface AMLDropdownmenuProps {
  anomalyId?: string;
  time_seen?: string;
  data?: any;
  timePeriod?: string;
  anomaly_type?: string;
  isModal?: boolean;
  event_names?: any;
  events?: EventProp[];
  dropdownType?: "anomaly" | "alert";
  getAdditionalData?: (data: any) => any;
  filterTime?: {
    filterTime: string;
    CustomFilter: string;
    fromDate: string;
    toDate: string;
  };
  excludeActions?: string[];
  anomaly_name?: string;
  usecaseId?: number;
}

const dataDefault = {
  anomaly_type: null,
  anomaly_id: null,
  globalID: null,
  sensor: null,
  anomalous_hostname: null,
  entity_type: null,
  time_seen: null,
  inserted_time: null,
  anomalous_ip: null,
  Time: null,
  dport: null,
  dip: null,
  data: null,
  anomalous_ip_mac: null,
  username: null,
  eventNames: null,
  score: null,
  eventData: null,
  category: null,
};

const AMLDropdownmenu: React.FC<AMLDropdownmenuProps> = ({
  data = dataDefault,
  isModal = false,
  // timePeriod = "day",
  filterTime,
  anomalyId,
  anomaly_type,
  time_seen,
  event_names,
  events,
  dropdownType = "anomaly",
  getAdditionalData = () => {},
  excludeActions = [],
  anomaly_name,
  usecaseId,
}) => {
  const [anomalyDialog, setAnomalyDialog] = useState(false);
  const [pcapDialog, setPcapDialog] = useState(false);
  const [anomalyTrustedDialog, setanomalyTrustedDialog] = useState(false);
  const [anomalyTuningDialog, setanomalyTuningDialog] = useState(false);
  const [pluginActionDialog, setpluginActionDialog] = useState(false);
  const [addToEmailDialog, setaddToEmailDialog] = useState(false);
  const [shadow350Url, setshadow350Url] = useState("");
  const [tcpResetDialog, setTcpResetDialog] = useState(false);
  // const [_downloadUrl, setDownloadUrl] = React.useState('')
  const custAnomDescRef = React.useRef<string>("");
  const [entityData, setEntityData] = React.useState<any>({});

  const [emailLoader, setemailLoader] = useState(false);
  const [addToDatalistDialog, setAddToDatalistDialog] =
    useState<boolean>(false);
  // const [automationStatus, setAutomationStatus] = useState<boolean>(false);

  const anmlId = anomalyId ?? data.anomalyId;
  const anomalyType = anomaly_type ?? data.anomaly_type;
  let anomalyTime = time_seen ?? data.time_seen;
  if (anomalyTime.toString().includes(".")) {
    anomalyTime = anomalyTime * 1000;
  }

  const {
    data: actionData,
    refetch: actionRefetch,
    isLoading: actionLoading,
    isRefetching: actionRefetching,
  } = useQuery(
    ["getActionDropdown", anmlId],
    ({ signal }) =>
      getActionDropdown(
        { anomalyId: anmlId, anomalyType, anomalyTime },
        signal,
      ),
    { enabled: false },
  );

  React.useEffect(() => {
    if (
      actionData &&
      "anomalies" in actionData &&
      actionData.anomalies.length > 0
    ) {
      // const evData = actionData?.anomalies[0].data && JSON.parse(actionData.anomalies[0].data);
      // const evId = evData?.events[0]?.Gid
      const anomId = actionData.anomalies[0].GlobalID;
      const anomAdditonalData = getAdditionalData(anomId);
      let tmpDesc = anomAdditonalData?.description;
      // remove html tags from desc and sanitize it
      if (tmpDesc) {
        tmpDesc = tmpDesc.replace(/<\/?[^>]+(>|$)/g, "");
        tmpDesc = tmpDesc.replace(/\s+/g, " ");
        custAnomDescRef.current = tmpDesc;
      }
    }
  }, [actionData]);
  React.useEffect(() => {
    if (actionData && "anomalies" in actionData) {
      let anomali_data = actionData.anomalies;
      if (
        anomali_data.length > 0 &&
        Object.prototype.toString.call(anomali_data[0]) === "[object Object]"
      ) {
        anomali_data = anomali_data[0];

        const newnames: any = {};
        if ("newData" in anomali_data) {
          anomali_data.newData.forEach((e: any) => {
            newnames[e.EventId] = e.EventName;
          });
        }
        data.anomaly_type = anomali_data.anomalyType;
        data.anomaly_id = anomali_data.anomaly_id;
        data.globalID = anomali_data.GlobalID;
        data.sensor = anomali_data.sensor;
        data.anomalous_hostname =
          anomali_data.anomalous_host ||
          anomali_data.anomalous_hostname ||
          anomali_data.anomalous_ip_mac ||
          anomali_data.anomalous_ip;
        data.entity_type = anomali_data.type;
        data.time_seen = anomali_data.time_seen;
        data.inserted_time = anomali_data.inserted_time;
        data.anomalous_ip = anomali_data.anomalous_ip;
        data.Time = anomali_data.time_str;
        data.dport = anomali_data.dport;
        data.dip = anomali_data.dip;
        data.data = "data" in anomali_data ? JSON.parse(anomali_data.data) : {};
        data.anomalous_ip_mac = anomali_data.anomalous_ip_mac;
        data.username =
          anomali_data.anomalous_hostname || anomali_data.anomalous_host;
        data.eventNames =
          event_names && Object.keys(event_names).length
            ? event_names
            : newnames;
        data.score = anomali_data.score;
        data.eventData = anomali_data.newData;
        data.events = events ?? [];
        data.category = anomali_data.category;
        if (custAnomDescRef.current && data.eventData.length > 0) {
          data.eventData[0].desc = custAnomDescRef.current;
        }

        const shadowProps: any = {};

        const _anomType =
          data.anomaly_type.toLowerCase() === "user"
            ? "user"
            : data.anomaly_type.toLowerCase() === "user-alert"
              ? "user-alert"
              : "entity";

        shadowProps["anomalyId"] = anomali_data.GlobalID;
        // Set startTime to 15 mins before the first event's Time if available
        let startTime = anomali_data.epochTime;
        let endTime = anomali_data.epochTime;
        if (events && Array.isArray(events) && events.length > 0) {
          const firstEventTime = events[0]?.Time;
          const isEventOfThresholdType = events[0]?.Threshold || "";
          if (firstEventTime) {
            // If Time is a string, try to parse it as int
            const eventEpoch =
              typeof firstEventTime === "string"
                ? parseInt(firstEventTime, 10)
                : firstEventTime;
            if (!isNaN(eventEpoch)) {
              if (isEventOfThresholdType == "") {
                startTime = eventEpoch - 15 * 60; // 15 minutes in seconds
                endTime = eventEpoch + 15 * 60; // 15 minutes in seconds
              } else {
                startTime = eventEpoch - 60 * 60; // 60 minutes in seconds
                endTime = eventEpoch + 15 * 60; // 60 minutes in seconds
              }
            }
          }
        }
        shadowProps["startTime"] = startTime;
        shadowProps["endTime"] = endTime;
        // shadowProps["logTypes"] = ["linkflow", "entity_anomalies"];
        const logTypes = ["linkflow", "event_logs"];
        anomali_data?.newData?.forEach((e: any) => {
          const evData = JSON.parse(e?.EventData);
          const logsrc = evData.log_source[0];
          if (!logTypes.includes(logsrc)) {
            logTypes.push(logsrc);
          }
        });

        const truncateText = (text: string, maxLength = 80) => {
          if (!text) return "";
          return text.length > maxLength
            ? text.slice(0, maxLength) + "..."
            : text;
        };
        const entityPayload = {
          ANOMALY_TYPE: anomali_data?.anomalyType || "",
          // anomaly_id: anomali_data?.anomaly_id || "",
          // globalID: anomali_data?.GlobalID || "",
          // sensor: anomali_data?.sensor || "",
          ENTITY_TYPE: anomali_data?.type || "",
          // time_seen: anomali_data?.time_seen || "",
          // inserted_time: anomali_data?.inserted_time || "",
          ANOMALOUS_IP: anomali_data?.anomalous_ip || "",
          ANOMALOUS_IP_MAC: anomali_data?.anomalous_ip_mac || "",
          ANOMALOUS_HOST:
            anomali_data?.anomalous_host ||
            anomali_data?.anomalous_hostname ||
            anomali_data?.hostname ||
            "",
          DESTINATION_PORT: anomali_data?.dport || "",
          DESTINATION_IP: anomali_data?.dip || "",
          SMAC: anomali_data?.smac || "",
          SIP: anomali_data?.sip || "",
          SCORE: anomali_data?.score || "",
          USERNAME:
            anomali_data?.anomalous_hostname ||
            anomali_data?.anomalous_host ||
            "",
          // eventNames: event_names ?? newnames,
          // eventData: anomali_data?.newData || [],
          // events: events ?? [],
          // data: "data" in anomali_data ? JSON.parse(anomali_data.data) : {},
          TIME: anomali_data?.Time || "",
          DESCRIPTION: truncateText(
            custAnomDescRef.current && anomali_data?.newData?.length > 0
              ? custAnomDescRef.current
              : anomali_data?.desc || "",
            30,
          ),
        };

        setEntityData(entityPayload);

        if (_anomType == "entity") {
          if (
            !logTypes.includes("entity_anomalies") &&
            dropdownType == "anomaly"
          ) {
            logTypes.push("entity_anomalies");
          } else if (
            !logTypes.includes("entity_alerts") &&
            dropdownType == "alert"
          ) {
            logTypes.push("entity_alerts");
          }
        } else if (_anomType === "user") {
          if (!logTypes.includes("user_anomalies")) {
            logTypes.push("user_anomalies");
          }
        } else if (_anomType === "user-alert") {
          if (!logTypes.includes("user_alerts")) {
            logTypes.push("user_alerts");
          }
        }
        shadowProps["logTypes"] = logTypes;
        const rawSearchValue =
          _anomType === "user" || _anomType === "user-alert"
            ? (anomali_data.Username ?? "")
            : (anomali_data.anomalous_ip ?? "");

        // Escape backslashes (e.g., john\Smith -> john\\Smith)
        shadowProps["searchValue"] = rawSearchValue.replace(/\\/g, "\\\\");
        shadowProps["searchType"] =
          _anomType === "user" || _anomType === "user-alert"
            ? "username"
            : "ip";
        shadowProps["sensor"] = anomali_data.sensor;

        const s360Url: string = getShadow360URL(shadowProps);
        setshadow350Url(s360Url);
      }
    }
  }, [actionData, actionRefetching]);

  const watchAddToEmailMutation = useMutation(addAnomalyToEmailList, {
    onSuccess: () => {
      toast({
        title: "Success",
        description: "Anomaly added to email list",
        variant: "success",
        duration: 3000,
      });
      setemailLoader(false);
    },
    onError: () => {
      toast({
        title: "Error",
        description: "An error occured!",
        variant: "destructive",
        duration: 3000,
      });
      setemailLoader(false);
    },
  });

  const anomaly_id = anomalyId ?? data["anomaly_id"];

  // const automationStatusMutation = useMutation(getAnomalyAutomationStatus, {
  //   onSuccess: () => {
  //     toast({
  //       title: "Success",
  //       variant: "success",
  //       duration: 3000,
  //     });
  //   },
  //   onError: () => {
  //     toast({
  //       title: "Error",
  //       description: "Failed to fetch automation status.",
  //       variant: "destructive",
  //       duration: 3000,
  //     });
  //   },
  // });

  // need for future use , not yet completed
  // const getAutomationStatus = () => {
  //   setAutomationStatus(true);
  //   if (data && data.globalID && data.time_seen) {
  //     const id = data.globalID ?? "";
  //     const time = data.time_seen ?? "";
  //     automationStatusMutation.mutate({
  //       anomalyId: id,
  //       anomalyTime: time,
  //     });
  //   } else {
  //     setAutomationStatus(false);
  //     toast({
  //       title: "Error",
  //       description: "Missing anomaly ID or time.",
  //       variant: "destructive",
  //       duration: 3000,
  //     });
  //   }
  // };

  function openPluginActionDialog() {
    setpluginActionDialog(true);
  }

  const [addToEmailTimeframe, setaddToEmailTimeframe] = useState("");

  function submitAddToEmail() {
    setemailLoader(true);
    watchAddToEmailMutation.mutate({
      anomaly_id: data["anomaly_id"] || anomaly_id,
      timeFrame: addToEmailTimeframe,
      type: data["entity_type"],
      anomalyType: data["anomaly_type"],
    });
  }

  const [incidentOpen, setincidentOpen] = useState(false);

  const closeIncident = () => {
    setincidentOpen(false);
  };

  const showincidentOverview = () => {
    setincidentOpen(true);
  };

  const eventids: Array<string> = [];

  if (event_names) {
    Object.keys(event_names).forEach((key: string) => {
      eventids.push(key);
    });
  } else if (data["eventNames"]) {
    Object.keys(data["eventNames"]).forEach((key: string) => {
      eventids.push(key);
    });
  }

  function createCaseTab() {
    sessionStorage.setItem(
      "anomIds",
      `[{"id": ${data.globalID}, "time": ${data.inserted_time}}]`,
    );
    sessionStorage.setItem("anomtype", data.anomaly_type);
    sessionStorage.setItem(
      "timeFrame",
      filterTime ? JSON.stringify(filterTime) : "",
    );
    sessionStorage.setItem("anomalous_ip", data.anomalous_ip);
    sessionStorage.setItem("anomalous_hostname", data.anomalous_hostname);

    const incidentParams = {
      anomalous_hostname: data.anomalous_hostname,
      anomalous_ip: data.anomalous_ip,
      anomalous_mac: data.anomalous_ip_mac,
      anomaly_id: data.anomaly_id,
      anomaly_type: data.anomaly_type,
      anomaly_time: data.Time,
      epoch_time: parseInt(data.inserted_time),
      globalID: data.globalID,
      score: "score" in data ? data.score : 0,
      name: "name" in data ? data.name : "",
      page: "incidentOverview",
      sourceIp: data?.eventData?.[0]?.SourceIp,
      sourceMac:
        data?.eventData?.[0]?.SourceMac || data?.eventData?.[0]?.AnomalousIpMac,
      destinationIp: data?.eventData?.[0]?.DestinationIp,
      question: "create case",
      case_automation: true,
    };
    window.open(
      `/case-management/?create=1&incidentParams=${encodeURIComponent(JSON.stringify(incidentParams))}`,
      "_blank",
    );
  }

  const sensor = actionData ? actionData.anomalies[0]?.sensor : "master";

  const pcapProps: any = events || [];
  pcapProps.map((event: any) => {
    event["Name"] = data?.eventNames?.[event.EventId] || event.EventName;
    event["Time"] = event._epoch ? event._epoch : event.Time;
  });

  const handleTcpReset = () => {
    setTcpResetDialog(true);
  };

  const canManageAmlActions = actionData?.can_manage_aml_actions === 1;
  return (
    <>
      {incidentOpen && (
        <IncidentOverview
          openState={incidentOpen}
          onClose={closeIncident}
          incidentProps={data}
        />
      )}

      {pluginActionDialog && actionData && "anomalies" in actionData && (
        <PluginActionDialog
          show={true}
          onClose={() => setpluginActionDialog(false)}
          anmlId={anmlId}
          anomalyTime={anomalyTime}
          anomalyType={anomalyType}
          entityData={entityData}
        />
      )}

      <Dialog
        open={addToEmailDialog}
        onOpenChange={() => {
          setTimeout(() => {
            setaddToEmailDialog(!addToEmailDialog);
          }, 100);
        }}
      >
        <DialogContent
          className="sm:max-w-[20vw]"
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle>Add Anomaly To Email List</DialogTitle>
          </DialogHeader>
          <div className="w-full">
            <Select
              value={addToEmailTimeframe}
              onValueChange={(it) => setaddToEmailTimeframe(it)}
            >
              <SelectTrigger className="w-full mt-2">
                <SelectValue placeholder="Select Timeframe" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Select Timeframe</SelectLabel>
                  <SelectItem value="Hourly">Hourly</SelectItem>
                  <SelectItem value="Every 6 Hours">Every 6 Hours</SelectItem>
                  <SelectItem value="Every 12 Hours">Every 12 Hours</SelectItem>
                  <SelectItem value="Daily">Daily</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="text-left w-full mt-2">
            {emailLoader ? (
              <Button type="submit">
                <Loader className="animate-spin" />
              </Button>
            ) : (
              <Button type="submit" onClick={submitAddToEmail}>
                Submit
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {anomalyTrustedDialog && (
        <TrustedListDialog
          show={true}
          onClose={() => setanomalyTrustedDialog(false)}
          data={data}
          permission={actionData}
        />
      )}

      {anomalyTuningDialog && events && events.length > 0 && (
        <AnomalyTuningModal
          show={true}
          onClose={() => setanomalyTuningDialog(false)}
          eventId={events[0].EventId}
          anomalyName={anomaly_name}
          data={data}
          usecaseId={usecaseId}
        />
      )}

      {tcpResetDialog && (
        <TcpResetDialog
          show={true}
          onClose={() => setTcpResetDialog(false)}
          data={data}
        />
      )}

      {addToDatalistDialog && (
        <AddToDataList
          show={true}
          onClose={() => setAddToDatalistDialog(false)}
          data={data}
          // permission={actionData}
        />
      )}

      {/* {automationStatus && (
        <AutomationStatus
          show={true}
          onClose={() => setAutomationStatus(false)}
          data={data}
        />
      )} */}

      {anomalyDialog && (
        <AnomalyFixedDialog
          header={`Fix ${dropdownType == "alert" ? "Alert" : "Anomaly"}`}
          anomalyId={anomalyId ?? data["anomaly_id"]}
          time={time_seen ?? data["time_seen"]}
          anomalyType={anomaly_type ?? data["anomaly_type"]}
          action={`fix${dropdownType}`}
          show={true}
          onClose={() => setAnomalyDialog(false)}
        />
      )}

      {pcapDialog && events && (
        <PcapDownloadDialog
          events={pcapProps}
          sensor={sensor}
          show={true}
          onClose={() => setPcapDialog(false)}
        />
      )}

      <DropdownMenu
        modal={isModal}
        onOpenChange={(e: boolean) => (e ? actionRefetch() : null)}
      >
        <DropdownMenuTrigger asChild>
          <ChevronDownSquare
            size={18}
            className="cursor-pointer inline-block text-primary"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-64" side="bottom" align="start">
          {actionLoading || actionRefetching ? (
            <DropdownMenuGroup>
              {Array.from(
                { length: dropdownType == "alert" ? 6 : 8 },
                (_, i) => (
                  <DropdownMenuItem key={i}>
                    <Loader
                      size={14}
                      className="inline-block me-2 animate-spin"
                    />
                    <div
                      className="inline-block p-3 bg-secondary rounded-sm"
                      style={{ width: Math.random() * 60 + 20 + "%" }}
                    ></div>
                  </DropdownMenuItem>
                ),
              )}
            </DropdownMenuGroup>
          ) : (
            <DropdownMenuGroup>
              <DropdownMenuItem
                className="cursor-pointer"
                onClick={() => showincidentOverview()}
              >
                <SearchIcon size={14} className="mr-3 inline-block" /> Incident
                Overview
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer">
                <a href={shadow350Url} rel="noreferrer" target="_blank">
                  <Play size={14} className="mr-3 inline-block" />
                  <span>Investigate in Shadow360</span>
                </a>
              </DropdownMenuItem>
              {canManageAmlActions &&
                actionData &&
                "isCaseView" in actionData &&
                actionData.isCaseView &&
                dropdownType == "anomaly" &&
                !excludeActions.includes("send_to_case_management") && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={createCaseTab}
                  >
                    <Send size={14} className="mr-3" /> Send to Case Management
                  </DropdownMenuItem>
                )}
              <DropdownMenuItem className="cursor-pointer">
                <a
                  target="_blank"
                  href={`/automation-builder/?anomIds=[{"id":"${anomalyId ?? data.anomalyId}","time":"${time_seen ?? data.time_seen}"}]&timeFrame=day&anomtype=${anomaly_type ?? data.anomaly_type}&category=${data.category || data.Category || ""}`}
                  rel="noreferrer"
                >
                  <Cog size={14} className="mr-3 inline-block" />
                  Automation
                </a>
              </DropdownMenuItem>
              {canManageAmlActions && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => setAnomalyDialog(true)}
                >
                  <WrenchIcon size={14} className="mr-3" />{" "}
                  {dropdownType == "alert" ? "Alert" : "Anomaly"} Fixed
                </DropdownMenuItem>
              )}
              {canManageAmlActions &&
                actionData &&
                "anomalies" in actionData &&
                actionData.anomalies.length > 0 &&
                "is_pcap_available" in actionData.anomalies[0] &&
                actionData.anomalies[0].is_pcap_available == "1" &&
                anomaly_type?.toLowerCase() == "entity" && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={() => setPcapDialog(true)}
                  >
                    <Download size={14} className="mr-3" /> Download Pcap
                  </DropdownMenuItem>
                )}
              {canManageAmlActions && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => setanomalyTrustedDialog(true)}
                >
                  <Badge size={14} className="mr-3" /> Add to Trusted List
                </DropdownMenuItem>
              )}
              {canManageAmlActions && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => setanomalyTuningDialog(true)}
                >
                  <SlidersHorizontal size={14} className="mr-3" /> Anomaly
                  Tuning
                </DropdownMenuItem>
              )}
              {canManageAmlActions && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={openPluginActionDialog}
                >
                  <PlugIcon size={14} className="mr-3" /> Plugin Actions
                </DropdownMenuItem>
              )}
              {canManageAmlActions &&
                anomaly_type?.toLowerCase() !== "user" &&
                !excludeActions.includes("tcp_reset") && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={handleTcpReset}
                  >
                    <RotateCcw size={14} className="mr-3 inline-block" />
                    Tcp Reset
                  </DropdownMenuItem>
                )}
              {canManageAmlActions && dropdownType == "anomaly" && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => setaddToEmailDialog(true)}
                >
                  <MailIcon size={14} className="mr-3" /> Add Anomaly to Email
                  List
                </DropdownMenuItem>
              )}
              {/* hiding for now , will do in 4.7.5 */}
              {/* {canManageAmlActions && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => getAutomationStatus()}
                >
                  <CircleDashed size={14} className="mr-3" />
                  Automation status
                </DropdownMenuItem>
              )} */}

              {canManageAmlActions &&
                !excludeActions.includes("add_to_datalist") && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={() => setAddToDatalistDialog(true)}
                  >
                    <ListPlus size={14} className="mr-3" />
                    Add to Datalist
                  </DropdownMenuItem>
                )}
            </DropdownMenuGroup>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default AMLDropdownmenu;
